import script from "./fclty-choc.vue?vue&type=script&setup=true&lang=js"
export * from "./fclty-choc.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__